import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useTranslation } from 'react-i18next';
import { theme } from './theme';

function CustomerNotesCard({ notes }) {
  const { t } = useTranslation();

  if (!notes || notes.length === 0) return null;

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.colors.surface,
        borderRadius: theme.radius.xl,
        padding: '20px',
        boxShadow: theme.shadows.md,
        marginBottom: '20px',
      }}
    >
      <Typography
        component="h3"
        sx={{
          fontSize: '16px',
          fontWeight: '700',
          margin: '0 0 16px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <ChatBubbleOutlineIcon sx={{ color: theme.colors.accent, fontSize: 20 }} />
        {t('public_maintenance.messages_from_workshop')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {notes.map((note) => (
          <Box
            key={note.id}
            sx={{
              padding: '14px 16px',
              backgroundColor: '#dbeafe',
              borderRadius: theme.radius.lg,
              borderLeft: `4px solid ${theme.colors.accent}`,
            }}
          >
            {note.text && (
              <Typography
                sx={{
                  margin: 0,
                  fontSize: '14px',
                  lineHeight: 1.6,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {note.text}
              </Typography>
            )}

            {/* Image gallery */}
            {note.images && note.images.length > 0 && (
              <Box
                sx={{
                  marginTop: note.text ? '12px' : 0,
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap',
                }}
              >
                {note.images.map((img) => (
                  <Box
                    key={img.id}
                    component="img"
                    src={img.thumbnail_url || img.url}
                    alt={img.original_filename || 'Image'}
                    onClick={() => window.open(img.url, '_blank')}
                    sx={{
                      width: 100,
                      height: 100,
                      objectFit: 'cover',
                      borderRadius: theme.radius.md,
                      cursor: 'pointer',
                      border: `1px solid ${theme.colors.accent}20`,
                      transition: 'transform 0.15s, opacity 0.15s',
                      '&:hover': {
                        transform: 'scale(1.02)',
                        opacity: 0.9,
                      },
                    }}
                  />
                ))}
              </Box>
            )}

            <Typography
              sx={{
                fontSize: '11px',
                color: theme.colors.textMuted,
                marginTop: '8px',
              }}
            >
              {formatTime(note.created_at)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default CustomerNotesCard;
